import { ReduxFeature } from 'Common/utils';
import * as actions from './actions';
import * as selectors from './selectors';
import reducers from './reducers';
import initialState from './state';

export default ReduxFeature.create({ actions, selectors, reducers, initialState });
